import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { ModalAccessOtherReportComponent } from 'src/app/modules/measure/modal-access-other-report/modal-access-other-report.component';
import { ModalMeasureReportComponent } from 'src/app/modules/measure/modal-measure-report/modal-measure-report.component';
import { ModalSelectReportComponent } from 'src/app/modules/measure/modal-select-report/modal-select-report.component';
import { ModalShareMeasureComponent } from 'src/app/modules/measure/modal-share-measure/modal-share-measure.component';
import { DatePipe } from '../../pipe/date.pipe';
import { ModalComponent } from '../modal/modal.component';
import { ModalShareComponent } from './modal-share/modal-share.component';
import { ModalPermissionAccessMeasureComponent } from 'src/app/modules/measure/modal-permission-access-measure/modal-permission-access-measure.component';
import { ModalInformantComponent } from 'src/app/modules/measure/modal-informant/modal-informant.component';
import { ModalShareInformantComponent } from 'src/app/modules/measure/modal-share-informant/modal-share-informant.component';

@Component({
  selector: 'lifedi-measure-card',
  templateUrl: './measure-card.component.html',
  styleUrls: ['./measure-card.component.scss']
})
export class MeasureCardComponent implements OnInit {
  @Input() data;
  @Input() type: string;
  @Input() researchMeasureStatus: boolean;
  @Input() researchID: string;
  @Input() start;
  @Input() end;
  @Input() waveID
  @Input() userEmail: string;

  currentDate: Date;
  statusButton: boolean;
  curdate
  mStartDate
  mEndDate
  isLoading: boolean;

  constructor(
    public matDialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private measureService: MeasureService
  ) { }

  ngOnInit(): void {
    // console.log(this.data);
    // // console.log(this.waveID);

    if (this.start && this.end) {
      this.currentDate = new Date();
      this.curdate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), 0, 0, 0).getTime();
      this.mStartDate = new Date(this.start).getTime();
      this.mEndDate = new Date(this.end).getTime();

      if (this.curdate >= this.mStartDate && this.curdate <= this.mEndDate) {
        this.statusButton = true;
      } else {
        this.statusButton = false;
      }

    } else if (!this.start && !this.end) {
      this.statusButton = true;
    }

  }

  share() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalRegister';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'Share',
      actionBtnText: 'ปิด',
      link: this.data.LINK_SHARE,
      isInformant: this.data.IS_MULTI_INFORMANT,
    }

    const modal = this.matDialog.open(ModalShareComponent, dialogConfig);
    modal.afterClosed().subscribe()
  }

  openDetail(link) {
    switch (this.data.IS_MULTI_INFORMANT) {
      case 0: {
        window.open(`/measure/${link}`, '_blank');
        break;
      }
      case 1: {
        window.open(`/measure/${link}?IS_MULTI_INFORMANT=1`, '_blank');
        break;
      }
      default: { break; }
    }
  }

  openMeasureResearch() {
    const queryParams: Params = { wave_id: this.waveID, research_id: this.researchID };
    this.router.navigate(
      ['/research/research-measure'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
  }

  colloectAccessLink(link) {
    this.measureService.colAccessLink(link);
    this.openMeasureResearch();
  }

  report() {
    this.isLoading = true;

    const dialogReportConfig = new MatDialogConfig();
    dialogReportConfig.disableClose = true;
    dialogReportConfig.id = 'modalShareMeasure';
    dialogReportConfig.width = '600px';
    dialogReportConfig.autoFocus = false;
    dialogReportConfig.data = {
      // IS_SHARE_MEASURE: this.data.IS_SHARE_MEASURE,
      // ACCESS_VIEW: this.data.ACCESS_VIEW,
      MEASURE_ID: this.data.MEASURE_ID,
      MEASURE_DONE: this.data.MEASURE_DONE,
    };

    const selectReportModal = this.matDialog.open(ModalSelectReportComponent, dialogReportConfig)
    return selectReportModal.afterClosed().pipe(
      switchMap(s => {
        if (s.status) {
          this.isLoading = false;
          if (s.value === 'other') {
            const dialogConfigSelectModal = new MatDialogConfig();
            dialogConfigSelectModal.disableClose = true;
            dialogConfigSelectModal.id = 'modalShareMeasure';
            dialogConfigSelectModal.width = '600px';
            dialogConfigSelectModal.autoFocus = false;
            dialogConfigSelectModal.data = {
              MEASURE_ID: this.data.MEASURE_ID
            }

            const otherReportModal = this.matDialog.open(ModalAccessOtherReportComponent, dialogConfigSelectModal);
            return otherReportModal.afterClosed().pipe(
              switchMap(report => {
                // console.log(report);
                if (report.value === 'email') {
                  const dialogConfigAddEmail = new MatDialogConfig();
                  dialogConfigAddEmail.disableClose = true;
                  dialogConfigAddEmail.id = 'modalAddEmail';
                  dialogConfigAddEmail.width = '600px';
                  dialogConfigAddEmail.autoFocus = false;
                  dialogConfigAddEmail.data = {
                    MEASURE_ID: this.data.MEASURE_ID
                  }

                  const shareModal = this.matDialog.open(ModalShareMeasureComponent, dialogConfigAddEmail);
                  return shareModal.afterClosed().pipe(
                    map(addReport => {
                      // console.log(addReport);

                    })
                  );
                } else if (report.value === 'selectReport') {
                  // console.log(report);
                  // console.log(report.report.MEASURE_CLIEND_ID);
                  let access_id = report.report.MEASURE_CLIEND_ID;
                  return this.measureService.getOtherModalPriceMeasure(report.report.MEASURE_ID, report.report.MEASURE_CLIEND_ID).pipe(
                    switchMap(ot => {
                      if (ot.success) {
                        this.isLoading = false;
                        // console.log(ot);

                        if (ot.result.report_data.length > 0) {
                          if (ot.result.report_data[0].TEMPLATE_FREE_TYPE || ot.result.report_data[0].TEMPLATE_NOTFREE_TYPE) {
                            const dialogConfig2 = new MatDialogConfig();
                            dialogConfig2.disableClose = true;
                            dialogConfig2.id = 'modalMeasureReport';
                            dialogConfig2.width = '600px';
                            dialogConfig2.autoFocus = false;
                            dialogConfig2.data = {
                              title: 'รายงานผล',
                              report: ot.result.report_data,
                              view_status: 0,
                              ROLE: ot.result.ROLE,
                            }

                            const reportModal = this.matDialog.open(ModalMeasureReportComponent, dialogConfig2);
                            this.isLoading = true;
                            return reportModal.afterClosed().pipe(
                              map(r => {
                                if (r.status) {
                                  this.isLoading = false;
                                  window.open('/test-report?type=' + r.report_type + '&paid=' + r.paid + '&mid=' + this.data.MEASURE_ID + '&view_status=' + r.view_status + '&access_id=' + access_id + '&informant_type=0', '_blank');

                                } else {
                                  this.isLoading = false;
                                  return of(null);
                                }
                              })
                            )
                          } else {

                            const dialogConfig3 = new MatDialogConfig();
                            dialogConfig3.disableClose = true;
                            dialogConfig3.id = 'modalConfirm';
                            dialogConfig3.width = '350px';
                            dialogConfig3.data = {
                              title: 'ยังไม่มีรายงานผล',
                              description: `<h5>แบบทดสอบนี้ยังไม่มีรายงานผล</h5>`,
                              cancleBtnText: 'ยืนยัน',
                              customStyle: 'background-color: #58595B;'
                            }

                            const modal = this.matDialog.open(ModalComponent, dialogConfig3);
                            return modal.afterClosed();
                            // return modal.afterClosed().pipe(
                            // map(res => {
                            //   if (!res) {
                            //     // console.log(res);
                            //   }
                            // })
                            // )

                          }

                        } else {

                          const dialogConfig3 = new MatDialogConfig();
                          dialogConfig3.disableClose = true;
                          dialogConfig3.id = 'modalConfirm';
                          dialogConfig3.width = '350px';
                          dialogConfig3.data = {
                            title: 'ยังไม่มีรายงานผล',
                            description: `<h5>ยังไม่มีรายงานผลของแบบทดสอบนี้</h5>`,
                            cancleBtnText: 'ยืนยัน',
                            customStyle: 'background-color: #58595B;'
                          }

                          const modal = this.matDialog.open(ModalComponent, dialogConfig3);
                          return modal.afterClosed().pipe(
                            // map(res => {
                            //   if (!res) {
                            //     // console.log(res);
                            //   }
                            // })
                          )

                        }
                      }
                    })
                  )
                } else {
                  // console.log(report);
                  return of(null);
                }
              })
            )
          } else if (s.value === 'myReport') {
            // my report
            return this.measureService.getModalPriceMeasure(this.data.MEASURE_ID).pipe(
              switchMap(res => {
                if (res.success) {
                  this.isLoading = false;
                  // console.log(res);

                  if (res.result.report_data.length > 0) {
                    if (res.result.report_data[0].TEMPLATE_FREE_TYPE || res.result.report_data[0].TEMPLATE_NOTFREE_TYPE) {
                      const dialogConfig2 = new MatDialogConfig();
                      dialogConfig2.disableClose = true;
                      dialogConfig2.id = 'modalMeasureReport';
                      dialogConfig2.width = '600px';
                      dialogConfig2.autoFocus = false;
                      dialogConfig2.data = {
                        title: 'รายงานผล',
                        report: res.result.report_data,
                        view_status: 0,
                        ROLE: res.result.ROLE,
                      }

                      const reportModal = this.matDialog.open(ModalMeasureReportComponent, dialogConfig2);
                      this.isLoading = true;
                      return reportModal.afterClosed().pipe(
                        map(r => {
                          if (r.status) {
                            console.log(r);
                            this.isLoading = false;
                            window.open('/test-report?type=' + r.report_type + '&paid=' + r.paid + '&mid=' + this.data.MEASURE_ID + '&view_status=' + r.view_status + '&informant_type=0', '_blank');
                          } else {
                            this.isLoading = false;
                            return of(null);
                          }
                        })
                      )
                    } else {

                      const dialogConfig3 = new MatDialogConfig();
                      dialogConfig3.disableClose = true;
                      dialogConfig3.id = 'modalConfirm';
                      dialogConfig3.width = '350px';
                      dialogConfig3.data = {
                        title: 'ยังไม่มีรายงานผล',
                        description: `<h5>แบบทดสอบนี้ยังไม่มีรายงานผล</h5>`,
                        cancleBtnText: 'ยืนยัน',
                        customStyle: 'background-color: #58595B;'
                      }

                      const modal = this.matDialog.open(ModalComponent, dialogConfig3);
                      return modal.afterClosed();
                      // return modal.afterClosed().pipe(
                      // map(res => {
                      //   if (!res) {
                      //     // console.log(res);
                      //   }
                      // })
                      // )

                    }

                  } else {

                    const dialogConfig3 = new MatDialogConfig();
                    dialogConfig3.disableClose = true;
                    dialogConfig3.id = 'modalConfirm';
                    dialogConfig3.width = '350px';
                    dialogConfig3.data = {
                      title: 'ยังไม่มีรายงานผล',
                      description: `<h5>ยังไม่มีรายงานผลของแบบทดสอบนี้</h5>`,
                      cancleBtnText: 'ยืนยัน',
                      customStyle: 'background-color: #58595B;'
                    }

                    const modal = this.matDialog.open(ModalComponent, dialogConfig3);
                    return modal.afterClosed().pipe(
                      // map(res => {
                      //   if (!res) {
                      //     // console.log(res);
                      //   }
                      // })
                    )

                  }
                }
              })
            )
          }
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        this.isLoading = false;
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null)
      })
    ).subscribe();

  }

  permission() {
    const dialogPermissionConfig = new MatDialogConfig();
    dialogPermissionConfig.disableClose = true;
    dialogPermissionConfig.id = 'modalShareMeasure';
    dialogPermissionConfig.width = '600px';
    dialogPermissionConfig.autoFocus = false;
    dialogPermissionConfig.data = {
      MEASURE_ID: this.data.MEASURE_ID
    }
    const modal = this.matDialog.open(ModalPermissionAccessMeasureComponent, dialogPermissionConfig);
  }

  informant() {
    const dialogInformantConfig = new MatDialogConfig();
    dialogInformantConfig.disableClose = true;
    dialogInformantConfig.id = 'modalInformantMeasure';
    dialogInformantConfig.width = '650px';
    dialogInformantConfig.autoFocus = false;
    dialogInformantConfig.panelClass = 'full-width-dialog';
    dialogInformantConfig.data = {
      MEASURE_ID: this.data.MEASURE_ID,
      userEmail: this.userEmail,
    }
    const informantModal = this.matDialog.open(ModalInformantComponent, dialogInformantConfig);
    // const modal = this.matDialog.open(ModalShareInformantComponent, dialogInformantConfig);
    informantModal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          if (res.type === 'change') {
            console.log(res.body)
            return this.measureService.inviteInformantMeasure(res.body).pipe(
              switchMap(res => {
                if (res.success) {

                  const successDialogConfig = new MatDialogConfig();
                  successDialogConfig.disableClose = true;
                  successDialogConfig.id = 'modalConfirm';
                  successDialogConfig.width = '350px';
                  successDialogConfig.data = {
                    title: 'ผู้ที่มีส่วนร่วมในการทำแบบทดสอบ',
                    description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                        <h5>ส่งคำเชิญสำเร็จ</h5>`,
                    cancleBtnText: 'ยืนยัน',
                    customStyle: 'background-color: #58595B;'
                  }

                  const modal = this.matDialog.open(ModalComponent, successDialogConfig);
                  return modal.afterClosed();
                } else {
                  return of(false);
                }
              })
            )
          } else if (res.type === 'report') {
            this.report();
            return of(null);
          }
        } else {
          return of(null);
        }
      }),
      catchError(error => {
        alert('ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง')
        return of(false);
      })
    ).subscribe();
  }


}
